import { Checkbox, Th } from "@chakra-ui/react";

import { Flex } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";

export function ThCheckbox() {
	const { selection } = useResource<unknown>();

	return (
		<Th aria-label="Select all" w="36px">
			<Flex justifyContent="center">
				<Checkbox
					colorScheme="teal"
					isChecked={selection.isAllSelected()}
					onChange={(e) => selection.handleSelectAll(e.target.checked)}
				/>
			</Flex>
		</Th>
	);
}
